// routes/_terms.copyright.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_terms.copyright')

export const handle = { name: 'copyright' }

export default dynamic(getClientModule, { ssr: false })
